/**
 * @module pricingList
 */

module.exports = function() {
    function showOrHideItems( btnMode, mode = 'show' ) {
        const hiddenItems = btnMode.closest( '.price-card' ).querySelectorAll( '.price-card-list > .hide-item' );
        hiddenItems.forEach( ( item ) => {
            item.classList.toggle( 'd-none', mode === 'hide' );
            item.classList.toggle( 'd-flex', mode === 'show' );
        } );
        btnMode.classList.add( 'd-none' );
    }

    document.querySelectorAll( '.button-show-all-items' ).forEach( ( btn ) => {
        btn.addEventListener( 'click', function() {
            showOrHideItems( this );
            this.nextElementSibling.classList.remove( 'd-none' );
        } );

        const hideButton = btn.nextElementSibling;
        hideButton.addEventListener( 'click', function() {
            showOrHideItems( this, 'hide' );
            this.previousElementSibling.classList.remove( 'd-none' );
        } );
    } );
}; // exports
